import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userSlice'
import experienceReducer from './experienceSlice'
import orgReducer from './orgSlice'

const store = configureStore({
	reducer: {
		user: userReducer,
		experience: experienceReducer,
		org: orgReducer,
	},
})

export default store
